// JsonPlugin.js
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";

export default function JsonPlugin({ onChange }) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerUpdateListener(({ editorState }) => {
            // Always read JSON when editor updates
            const json = editorState.toJSON();
            if (onChange) {
                onChange(json);
            }
        });
    }, [editor, onChange]);

    return null;
}
